import { useTranslation } from 'react-i18next';
import { BaseDialog } from '@/common/components/base-dialog/BaseDialog';
import type { PicklistOption } from './types';

interface PicklistSelectionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  options: readonly PicklistOption[];
  excludedOptionIds?: readonly number[];
  onSave: (optionId: number) => void;
  title: string;
}

export const PicklistSelectionDialog = ({
  open,
  onOpenChange,
  options,
  excludedOptionIds,
  onSave,
  title,
}: PicklistSelectionDialogProps) => {
  const { t } = useTranslation();
  const visibleOptions = options.filter((opt) => !excludedOptionIds?.includes(opt.id));

  return (
    <BaseDialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      className="z-1400! h-4/6 overflow-hidden flex flex-col"
    >
      <div className="flex flex-col gap-2 overflow-auto flex-1 min-h-0">
        {visibleOptions.length === 0 ? (
          <span className="text-sm text-text-neutral-secondary p-3">
            {t(($) => $.picklistTable.noPicklistOptionsFound)}
          </span>
        ) : (
          visibleOptions.map((option) => (
            <button
              key={option.id}
              type="button"
              data-testid={`picklist-option-${option.id}`}
              onClick={() => {
                onSave(option.id);
                onOpenChange(false);
              }}
              className="flex items-center p-3 text-left text-sm hover:bg-bg-neutral-subtle/50 transition-colors rounded-md"
            >
              {option.name}
            </button>
          ))
        )}
      </div>
    </BaseDialog>
  );
};
